import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";
import { Colors } from "../../config/Constants";
import Labels from "./Labels";
import { getParkingLayout } from "../../services/yachtClubService";
import Layout from "./Layout";
import Spot from "./Spot";
import { ToastMessage } from "../../components/ToastMessage";
import { toast } from "react-toastify";
import { useLoadContext } from "../../contexts/LoadContext";
import { useYachtContext } from "../../contexts/YachtContext";

const ParkingLayout = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [selectedSpot, setSpot] = useState("");
  const location = useLocation();
  const isViewLayout = location.pathname === "/admin/layout" ? true : false;
  const [layoutData, setLayoutData] = useState([]);
  const { setLoader } = useLoadContext();
  const { setBerthID } = useYachtContext();

  useEffect(() => {
    fetchLayoutData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLayoutData = async () => {
    setLoader(true);
    try {
      let res = await getParkingLayout();
      console.log("res", res);
      setLayoutData(res.data.data);
    } catch (error: any) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoader(false);
  };

  return (
    <>
      <PicButtonContainer>
        <Layout />
        {isViewLayout && (
          <BackButtonWrapper>
            <Button
              label="Back"
              isRounded={true}
              width={"120px"}
              outlineColor={Colors.white}
              onClick={() => navigate("/admin/yacht-club")}
            />
          </BackButtonWrapper>
        )}
      </PicButtonContainer>
      <ParkingSpotContainer>
        <ParkingSpotTitle>
          {!isViewLayout && "Choose"} Parking Spot
        </ParkingSpotTitle>
        <ParkingSpotChipContainer>
          <ParkingSpotSection>
            <ParkingSpotHeader>North</ParkingSpotHeader>
            <SpotGroup>
              {layoutData.map((spot: any) => (
                <>
                  {spot.dockLocation.dockLocation === "north" && (
                    <Spot
                      label={spot.dockLocation.code}
                      isSelected={spot.dockLocation.code === selectedSpot}
                      isAvailable={!spot.isParked}
                      onClick={
                        isViewLayout
                          ? () => {}
                          : (val) => {
                              setSpot(val);
                              setBerthID(spot.dockLocation._id);
                            }
                      }
                    />
                  )}
                </>
              ))}
            </SpotGroup>
          </ParkingSpotSection>
          <ParkingSpotSection>
            <ParkingSpotHeader>South</ParkingSpotHeader>
            <SpotGroup>
              {layoutData.map((spot: any) => (
                <>
                  {spot.dockLocation.dockLocation === "south" && (
                    <Spot
                      label={spot.dockLocation.code}
                      isSelected={spot.dockLocation.code === selectedSpot}
                      isAvailable={!spot.isParked}
                      onClick={
                        isViewLayout
                          ? () => {}
                          : (val) => {
                              setSpot(val);
                              setBerthID(spot.dockLocation._id);
                            }
                      }
                    />
                  )}
                </>
              ))}
            </SpotGroup>
          </ParkingSpotSection>
          <ParkingSpotSection>
            <ParkingSpotHeader>East</ParkingSpotHeader>
            <SpotGroup>
              {layoutData.map((spot: any) => (
                <>
                  {spot.dockLocation.dockLocation === "east" && (
                    <Spot
                      label={spot.dockLocation.code}
                      isSelected={spot.dockLocation.code === selectedSpot}
                      isAvailable={!spot.isParked}
                      onClick={
                        isViewLayout
                          ? () => {}
                          : (val) => {
                              setSpot(val);
                              setBerthID(spot.dockLocation._id);
                            }
                      }
                    />
                  )}
                </>
              ))}
            </SpotGroup>
          </ParkingSpotSection>
        </ParkingSpotChipContainer>
      </ParkingSpotContainer>
      <ActionContainer>
        <div>
          <Labels label="Available Berth" type="available" />
          {!isViewLayout && <Labels label="Selected Berth" type="selected" />}
          <Labels label="Booked Berth" type="booked" />
        </div>
        {!isViewLayout && (
          <div>
            <Button width="150px" onClick={() => navigate(-1)} label="Cancel" />
            <Button
              width="150px"
              variant="filled"
              color={Colors.red}
              onClick={() => {
                navigate(`/admin/view-details/${state.id}`, {
                  state: { selectedSpot: selectedSpot },
                });
              }}
              label="Save"
              disabled={selectedSpot === ""}
            />
          </div>
        )}
      </ActionContainer>
    </>
  );
};

const ParkingSpotContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 0.5rem;
`;

const ParkingSpotTitle = styled.div`
  font-size: 1.5rem;
`;

const ParkingSpotChipContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const ParkingSpotSection = styled.div`
  flex: 1;
`;

const ParkingSpotHeader = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0.75rem 0;
`;

const SpotGroup = styled.div`
  gap: 0.5rem;
`;

const ActionContainer = styled.div`
  justify-content: space-between;
  display: flex;
  padding: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
  > div {
    gap: 1rem;
    display: flex;
    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
  > div:first-child {
    padding-top: 1rem;
    border-top: 2px solid ${Colors.gainsboro}88;
  }
  > div:last-child {
  }
`;
const PicButtonContainer = styled.div`
  position: relative;
`;
const BackButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin: 1rem 1rem 0 0;
`;

export default ParkingLayout;
